import { Handle, Position } from '@xyflow/react';
import { type SimpleNodeData } from '../../../types/node-data';

export const EndNode = ({ data }: { data: SimpleNodeData }) => {
  return (
    <div
      className='px-4 py-2 rounded-full font-medium min-w-[120px] text-center'
      style={{ backgroundColor: 'rgb(22, 163, 74)', color: 'rgb(240, 253, 244)' }}
    >
      <Handle type='target' position={Position.Left} />
      {data.label}
    </div>
  );
};
